export enum CapacityFormat {
    Standard = 'Standard',
    Mini = 'Mini',
}
